import React, { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

// Lazy load the EmailEditor component
const EmailEditor = React.lazy(() => import('./EmailEditor').then(module => ({ default: module.EmailEditor })));

// Loading component for the Suspense fallback
const EmailEditorLoader = () => (
  <div className="flex items-center justify-center h-64 border border-gray-200 rounded-md bg-gray-50">
    <div className="flex flex-col items-center gap-2">
      <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      <p className="text-sm text-gray-500">Loading editor...</p>
    </div>
  </div>
);

// Wrapper component that provides the lazy loading functionality
export const LazyEmailEditor = (props: React.ComponentProps<typeof EmailEditor>) => {
  return (
    <Suspense fallback={<EmailEditorLoader />}>
      <EmailEditor {...props} />
    </Suspense>
  );
};

// Export the prop types for type safety
export type LazyEmailEditorProps = React.ComponentProps<typeof EmailEditor>;